<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
		[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<app-loader *ngIf="!dataIsLoaded"></app-loader>
<section class="main-side-nav" *ngIf="dataIsLoaded"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container dynamic-view-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span *ngIf="myUser.sharedPlanUserId">Shared Plans <i class="fa fas fa-chevron-right"></i></span>
				<span *ngIf="!myUser.sharedPlanUserId">My Plan <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'View'" [isTopLevel]="true"></app-breadcrumb>
				<span *ngIf="myUser.sharedPlanUserId">
					{{" - " + myUser.delegate.clientFirstName + " " + myUser.delegate.clientLastName}}
				</span>
			</div>
			<div class="title-container">
				<header>
					<div class="back-fa" (click)="goto()">
						<i class="fa fas fa-chevron-left"></i>
					</div>
					<h1>{{myFormTemplate.subject}}</h1>
				</header>
				<input *ngIf="canEdit && myFormTemplate.subject != 'View General Expenses'" type="button"
					class="btn btn btn-primary primary-default-btn" (click)="add()" value="+Add">
			</div>
		</section>
		<section class="action-update">
			<section class="buttons-container">
				<div class="edit-btn">
					<i class="fa fas fa-pencil-alt"></i>
					<input *ngIf="canEdit" type="button" class="btn btn btn-primary primary-sml-btn" value="Edit"
						(click)="editItem()">
				</div>
				<div class="delete-btn">
					<i class="fa fas fa-trash"></i>
					<input *ngIf="canEdit" type="button" class="btn btn btn-primary primary-sml-btn" value="Delete"
						(click)="callDialog()">
				</div>
			</section>
			<div class="last-update">
				Last updated by {{lastUpdateByName}} on {{myItem.lastUpdate | date: 'dd/MM/yyyy'}}
			</div>
		</section>
		<section class="dynamic-system">
			<form [formGroup]="myFormGroup" (ngSubmit)="onSubmit()">
				<section class="dynamic-system-header">
					<ng-container *ngFor="let form_elem of myFormTemplate.fields">
						<section [ngSwitch]="form_elem.inputtype" class="data-view-flex">
							<section *ngSwitchCase="'freetext'" class="freetext">
								<!-- If an income is not yet being drawn -->
								<div class="form-group" *ngIf="form_elem.label == 'Expected start date'">
									<div>
										<label>Currently Drawing Income</label>
									</div>
									<div class="check-fa-group">
										<input type="text" value="No" readonly />
									</div>
								</div>
								<div class="form-group" *ngIf="form_elem.geFrenquency != true">
									<div>
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
									</div>
									<div class="check-fa-group">
										<ng-container *ngIf="form_elem.fieldid != 'notes'">
											<input type="text" formControlName="{{form_elem.fieldid}}"
												required="{{form_elem.mandatory}}" readonly
												[ngClass]="{makeDisappear: form_elem.fieldid == 'perMonthYear' && (myFormGroup.get(form_elem.fieldid).value == 'Per Month' || myFormGroup.get(form_elem.fieldid).value == 'Per Year')}" />
											<span class="per-month-year"
												*ngIf="form_elem.fieldid == 'perMonthYear' && myFormGroup.get(form_elem.fieldid).value == 'Per Month'">Monthly</span>
											<span class="per-month-year"
												*ngIf="form_elem.fieldid == 'perMonthYear' && myFormGroup.get(form_elem.fieldid).value == 'Per Year'">Annually</span>
										</ng-container>
										<ng-container *ngIf="form_elem.fieldid == 'notes'">
											<textarea [ngClass]="{heightTextArea: form_elem.fieldid == 'notes'}"
												formControlName="{{form_elem.fieldid}}">
											</textarea>
										</ng-container>
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'personToNotifyForDigitalLegacy'">
								<div class="form-group">
									<div>
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'jointOwnersList'" class="dropdownid">
								<div class="form-group">
									<div>
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
									</div>
									<div class="check-fa-group notes-memo joint-owners-list">
										<div class="owner-info-title row">
											<div class="owner-name-title col-sm-3">Owner</div>
											<div class="owner-is-common-title col-sm-3">Ownership Type</div>
											<div class="owner-share-title col-sm-3" *ngIf="isCommon">Ownership % share
											</div>
										</div>
										<div class="owner-info row" *ngFor="let owner of jointOwnersList">
											<div class="owner-name col-sm-3">{{owner.owner.first + " " +
												owner.owner.last}}</div>
											<div class="is-common col-sm-3" *ngIf="isCommon">Tenants in common</div>
											<div class="is-common col-sm-3"
												*ngIf="!isCommon && jointOwnersList.length>=2">Joint Tenant</div>
											<div class="is-common col-sm-3"
												*ngIf="!isCommon && jointOwnersList.length<2">Owner</div>
											<div class="owner-share col-sm-3" *ngIf="owner.share && owner.share != 100">
												{{owner.share}}%</div>
										</div>
										<!-- {{myFormGroup.get(form_elem.fieldid).value | json}} -->
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'dropdownid'" class="dropdownid">
								<div class="form-group">
									<div>
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
									</div>
									<div class="check-fa-group">
										<select class="form-control" formControlName="{{form_elem.fieldid}}"
											[ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
											<option *ngFor="let opt of form_elem.itemArray" value="{{opt.Id}}">
												{{opt.itemName}}
											</option>
										</select>
									</div>
								</div>
							</section>
							<section class="information-label" *ngIf="false">
								<div class="form-group">
									<label class="col-sm-12">{{form_elem.explanation}}</label>
								</div>
							</section>
							<section *ngSwitchCase="'memofree'" class="memofree">
								<div class="form-group" *ngIf="myFormGroup.get(form_elem.fieldid).value">
									<div>
										<label>{{form_elem.label}}</label>
									</div>
									<div class="check-fa-group notes-memo">
										{{myFormGroup.get(form_elem.fieldid).value}}
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'memo'" class="memo">
								<div class="form-group">
									<div>
										<label>{{form_elem.label}}</label>
									</div>
									<div class="check-fa-group notes-memo">
										{{myFormGroup.get(form_elem.fieldid).value}}
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'number'" class="number">
								<div class="form-group">
									<div>
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}
											<ng-container
												*ngIf="showFrequencies && myFormGroup.value[form_elem.fieldid+'Freq']">
												{{myFormGroup.value[form_elem.fieldid + 'Freq']}}
											</ng-container>
											<span
												*ngIf="currencyTypeDisplay[form_elem.fieldid]">({{currencyTypeDisplay[form_elem.fieldid]}})</span>
											<span *ngIf="form_elem.percent">({{form_elem.percent}})</span>

										</label>
									</div>
									<div class="check-fa-group number-format">
										<ng-container *ngIf="isCurrency[form_elem.fieldid]">
											{{currencyValue[form_elem.fieldid] | number }}
										</ng-container>
										<ng-container *ngIf="!isCurrency[form_elem.fieldid]">
											{{myFormGroup.get(form_elem.fieldid).value}}
											{{form_elem.percent}}
										</ng-container>
									</div>
								</div>
								<div class="form-group"
									*ngIf="totalSharesValue>0 && form_elem.fieldid=='shareCount' && form_elem.unlistedShare && form_elem.unlistedShare != true">
									<div>
										<label>Total Value of Shares</label>
										<div class="check-fa-group">
											<span class="shareCount">{{totalSharesValue|
												currency:'GBP':'symbol-narrow':'1.0'}}</span>
										</div>
									</div>
								</div>
							</section>
							<section *ngSwitchCase="'datepicker'" class="datepicker">
								<div class="form-group">
									<div>
										<label>{{form_elem.label}}
											<span class="required-field">{{form_elem.required}}</span>
										</label>
									</div>
									<div class="check-fa-group">
										<input type="date" readonly formControlName="{{form_elem.fieldid}}"
											min="1890-01-01" max="2050-12-31">
									</div>
								</div>
								<div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors"
									class="invalid-feedback">
									<div *ngIf="form_elem.mandatory">This is a required field.</div>
								</div>
							</section>
							<section *ngSwitchCase="'multicheckbox'" class="conditionaldropdown-dynamic">
								<div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
									<div class="form-group">
										<label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
										<app-multi-checkbox [parentForm]="myFormGroup" [fieldId]="form_elem.fieldid"
											[listSource]="form_elem.listSource" [arrayOptions]="form_elem.options"
											[label]="form_elem.label" [view]="true"></app-multi-checkbox>
									</div>
								</div>
							</section>
						</section>
					</ng-container>
					<section class="upload">
						<label>Attachments</label>
						<app-file-upload [itemId]="Id" [readOnly]="true">
						</app-file-upload>
					</section>
				</section>
				<section class="dynamic-system-main">
					<section class="dynamic-system-content">
						<div class="manage-buttons">
							<div class="edit-btn">
								<i class="fa fas fa-pencil-alt"></i>
								<input *ngIf="canEdit" type="button" class="btn btn btn-primary primary-sml-btn"
									value="Edit" (click)="editItem()">
							</div>
							<div class="delete-btn">
								<i class="fa fas fa-trash"></i>
								<input *ngIf="canEdit" type="button" class="btn btn btn-primary primary-sml-btn"
									value="Delete" (click)="callDialog()">
							</div>
						</div>
					</section>
					<app-dialog [visible]="showDialog" [itemName]="itemNameforDialog"
						[sectionName]="myFormTemplate.sectionTitle" (dialogAnswer)="deleteByEvent($event)">
					</app-dialog>
				</section>
			</form>
		</section>
	</section>
</section>